import swal from "sweetalert";

export default function messagePopup(header, text, color) {
    swal(header, text, color);
}



